import React from 'react';

/** A habit's day total, as a chip in the closing ritual. */
export function TrackerChip({ name, done = 0, goal = 1, onClick, style }) {
  const hit = done >= goal;
  return (
    <span onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 'var(--bujo-space-2)',
      padding: '6px 8px', minHeight: 30,
      border: hit ? '1px solid color-mix(in srgb, var(--bujo-label) 50%, transparent)'
                  : '1px solid var(--bujo-rule-hairline)',
      background: hit ? 'color-mix(in srgb, var(--bujo-label) 9%, transparent)' : 'transparent',
      font: 'var(--bujo-fw-medium) 10.5px/var(--bujo-lh-tight) var(--bujo-font-mono)',
      color: hit ? 'var(--bujo-text-primary)' : 'var(--bujo-text-dim)',
      cursor: onClick ? 'pointer' : 'default', ...style
    }}>
      {name}
      <span style={{ color: hit ? 'var(--bujo-label)' : 'var(--bujo-text-meta)' }}>{done}/{goal}</span>
    </span>
  );
}
